import { render, staticRenderFns } from "./PartDrawer.vue?vue&type=template&id=f72d3246"
import script from "./PartDrawer.vue?vue&type=script&lang=js"
export * from "./PartDrawer.vue?vue&type=script&lang=js"
import style0 from "./PartDrawer.vue?vue&type=style&index=0&id=f72d3246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports